<template>
  <!-- Mission List Popup -->
  <div>
    <el-dialog
      title="Tin nhắn"
      :visible.sync="mainDialogVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <!-- <div class="das-form-container"> -->
      <div class="das-info-title">
        Thông tin đặt phòng {{ bookingInfo.booking_group_code }}
      </div>
      <hr />
      <InfoList :columns="3">
        <InfoListLabel>Tên khách</InfoListLabel>
        <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

        <InfoListLabel>Ngày đến</InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_in_date)
        }}</InfoListValue>

        <InfoListLabel>Đoàn</InfoListLabel>
        <InfoListValue>{{ bookingInfo.booking_group_name }}</InfoListValue>

        <InfoListLabel>Số điện thoại</InfoListLabel>
        <InfoListValue>{{ bookingInfo.phone_number }}</InfoListValue>

        <InfoListLabel>Ngày đi </InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_out_date)
        }}</InfoListValue>

        <InfoListLabel>Công ty, đại lý du lịch</InfoListLabel>
        <InfoListValue>{{ bookingInfo.agent_name }}</InfoListValue>
      </InfoList>
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="missionListGrid"
          :columns="cols"
          dom-layout="scroll"
          :auto-select-first-row="false"
          :rows="rows"
          class="agGrid"
          @selectionChanged="onSelectionChange"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="mainDialogVisible = false"
          >
            Đóng
          </button>
          <!-- Messages -->
          <div class="flex gap-10">
            <button
              :disabled="
                rowsSelected.length === 0 || rowsSelected[0]?.status === 3
              "
              class="btn primary small outline"
              @click="openCancelMessageDialog()"
            >
              Hủy
            </button>
            <button
              :disabled="
                rowsSelected.length === 0 ||
                rowsSelected[0]?.status === 2 ||
                rowsSelected[0]?.status === 3
              "
              class="btn primary small"
              @click="onSendMessage()"
            >
              Gửi
            </button>
            <button
              :disabled="rowsSelected.length === 0"
              class="btn primary small"
              @click="openEditDialog()"
            >
              Chi tiết
            </button>
            <button class="btn primary small" @click="openAddDialog()">
              Thêm
            </button>
          </div>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      :title="isEdit ? 'Chi tiết tin nhắn' : 'Thêm tin nhắn'"
      :visible="addDialogVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="resetAddDialog"
    >
      <validation-observer ref="addFormValidator">
        <div class="das-form-container" style="position: relative">
          <div
            v-if="rowsSelected.length > 0 && rowsSelected[0]?.status !== 1"
            class="transparent-overlay"
          ></div>
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:50" name="Người gửi">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Người gửi</span>
                    </div>
                    <input v-model="submitForm.sender" type="text" />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|number|max:20"
                  name="Số điện thoại"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Số điện thoại</span>
                    </div>
                    <input v-model="submitForm.phone_num" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required" name="Mục đích">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Mục đích</span>
                    </div>
                    <input v-model="submitForm.purpose" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="max:200" name="Ghi chú">
                  <div class="das-form-input">
                    <div class="label">
                      <span>Ghi chú</span>
                    </div>
                    <textarea v-model="submitForm.content" :rows="3" />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addDialogVisible = false"
          >
            Đóng
          </button>
          <button
            v-if="isEdit"
            :disabled="rowsSelected[0]?.status !== 1"
            class="btn primary small"
            @click="onUpdate()"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="onSubmitNew()">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Hủy tin nhắn"
      :visible="cancelMessageDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <validation-observer ref="cancelFormValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:200" name="Ghi chú">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Ghi chú</span>
                    </div>
                    <textarea v-model="cancelMessageForm.note" :rows="3" />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="cancelMessageDialog = false"
          >
            Hủy
          </button>
          <button class="btn primary small" @click="submitCancelMessage()">
            {{ $t('button.update') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addForm,
  // handleRow,
  getMessages,
  sendMessageApi,
  submitCancelMessageApi,
  onUpdateMessageApi
} from '@/api/cashier_service/postTransaction'
export default {
  data() {
    return {
      isEdit: false,
      mainDialogVisible: false,
      addDialogVisible: false,
      rowsSelected: [],
      submitForm: {
        sender: null,
        phone_num: null,
        purpose: null,
        content: null,
        sub_booking_group_id: null
      },
      cols: [
        {
          headerName: 'Người gửi',
          field: 'sender',
          tooltipField: 'sender',
          maxWidth: 150
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          valueGetter: param => {
            switch (param?.data.status) {
              case 1:
                return 'Chưa gửi'
              case 2:
                return 'Đã gửi'
              case 3:
                return 'Đã hủy'
              default:
                return null
            }
          },
          tooltipValueGetter: param => {
            switch (param?.data.status) {
              case 1:
                return 'Chưa gửi'
              case 2:
                return 'Đã gửi'
              case 3:
                return 'Đã hủy'
              default:
                return null
            }
          },
          maxWidth: 150
        },
        {
          headerName: 'Mục đích',
          field: 'purpose',
          tooltipField: 'purpose',
          maxWidth: 150
        },
        {
          headerName: 'Số điện thoại',
          field: 'phone_num',
          tooltipField: 'phone_num'
        },
        {
          headerName: 'Nội dung',
          field: 'content',
          tooltipField: 'content',
          minWidth: 250
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note',
          minWidth: 250
        }
      ],
      rows: [],
      // ***************************************
      cancelMessageDialog: false,
      cancelMessageForm: {
        note: null
      }
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    }
  },
  watch: {
    cancelMessageDialog() {
      this.cancelMessageDialog
        ? null
        : this.$nullValueInObj(this.cancelMessageForm)
    }
  },
  methods: {
    openEditDialog() {
      this.isEdit = true
      Object.assign(this.submitForm, this.rowsSelected[0])
      this.addDialogVisible = true
    },
    async onUpdate() {
      await onUpdateMessageApi(this.submitForm)
        .then(async res => {
          const message = res.message
          this.addDialogVisible = false
          this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async onSubmitNew() {
      if ((await this.$vxForm.isValid(this.$refs.addFormValidator)) === false) {
        return
      }
      const url = '/cashier-service/v1/room-message'
      this.submitForm.sub_booking_group_id = this.bookingInfo.id
      await addForm(url, this.submitForm)
        .then(async res => {
          const message = res.message
          this.addDialogVisible = false
          this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      const data = await getMessages({
        sub_booking_group_id: this.bookingInfo.id
      })
      this.rows = data.data || []
      this.rowsSelected = []
    },
    async getInitData() {
      await this.attachData()
      this.mainDialogVisible = true
      // this.submitForm.sub_booking_group_id = this.bookingInfo.id
    },
    openAddDialog() {
      this.addDialogVisible = true
    },
    resetAddDialog() {
      this.isEdit = false
      this.$nullValueInObj(this.submitForm)
    },
    onSelectionChange(rows) {
      this.rowsSelected = rows
    },
    // *********************************
    async onSendMessage() {
      const id = this.rowsSelected[0].id
      await sendMessageApi(id)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.attachData()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    openCancelMessageDialog() {
      this.cancelMessageDialog = true
    },
    async submitCancelMessage() {
      if (
        (await this.$vxForm.isValid(this.$refs.cancelFormValidator)) === false
      ) {
        return
      }
      const id = this.rowsSelected[0].id
      await submitCancelMessageApi(id, this.cancelMessageForm)
        .then(async res => {
          const message = res.message
          this.cancelMessageDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.attachData()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    }
  }
}
</script>
